import Order from '~/models/read/Order';
import jsonapi from 'jsonapi-parse';
import Money from '~/models/Money';

export default $axios => ({ store }) => ({
    uploadDocument(file) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append('uploadfiletype[file]', file);

            $axios.$post('/order/essay/document/', formData, {
                ignoreLogout: true,
                headers: {
                    'Content-Type': 'multipart/form-data',
                } }).then((response) => {
                resolve(new Order(response.data));
            })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    async getEssayEditingPricing() {
        try {
            let response = await $axios.$get(`/api/v1/essay/pricing/`, { noAuthHeader: true });

            return response.data;
        } catch (error) {
            return [];
        }
    },

    async getSetupFee() {
        try {
            let response = await $axios.$get(`/api/v1/ordering/setup-fee/${store.domain}/essay_editing_and_coaching`, { noAuthHeader: true });

            return jsonapi.parse(response.data).map(i => new Money(i.attributes));
        } catch (error) {
            return [];
        }
    },

    async submit(formData) {
        let response = await $axios.post(`/order/essay/`, formData, { withCredentials: true, ignoreLogout: true });
        return response;
    },
});
